<template>
  <Form 
    :d_form='form'
    :d_no_tangki='no_tangki'
     v-if="id > 0 && load == 2"
  /> 

  
  <Form 
    :d_form='form'
    :d_no_tangki='no_tangki'
    v-else-if="id == 0 && load == 1"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki.selenggara',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Selenggara Tangki', route: '/tangki/selenggara' },
      ],
      title : 'Selenggara Tangki',
      form : {
        id : 0,
        tarikh : '',
        no_tangki : '',
        seebelum : '',
        selepas : '',
        isipadu_topup_l : '',
        isipadu_topup_m : '',
        
        
      },
      tarikh : [],
      no_tangki : [],
      seebelum : [],
      selepas : [],
      kapasiti : [],
      isipadu_topup_l : [],
      isipadu_topup_m : [],
      load : 0
      
      
    }
  },
  methods: {
    

  

 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki_selenggara/show/'+this.id, {}).then(res => {
          
          this.form = res
          this.load = this.load + 1

        })
      }
    },
    
    getTangki(){
      this.$zcomm.get(this.api_service + 'lookup/tangki', {}).then(res => {
        this.no_tangki = res
        this.load = this.load + 1
      })
    },
  
  },

  watch: {

  },
  mounted() {
    this.getTangki()
    this.getData()
    
  }
    
}
</script>
